import { useEffect, useState } from 'react'

import { getEntityClosedReasons } from '../api'
import { selectClosedLostReasons } from '../slice'
import type { ENTITY_TYPES } from '@sales-center/common'
import { useAppDispatch, useAppSelector } from '@user/store/hooks'

export function useGetEntityCloseReasonsOnMount(props: {
  entityType: ENTITY_TYPES
  salesFunnelId: number
}) {
  const { entityType, salesFunnelId } = props
  const dispatch = useAppDispatch()
  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      const result = await dispatch(
        getEntityClosedReasons({
          entityType,
          salesFunnelId,
        }),
      )
      if (mounted) {
        if (getEntityClosedReasons.fulfilled.match(result)) setStatus('success')
        else setStatus('fail')
      }
    }
    if (salesFunnelId && salesFunnelId != 0) {
      execute()
    }

    return () => {
      mounted = false
    }
  }, [dispatch, entityType, salesFunnelId])

  const reasonDetail = useAppSelector((state) =>
    selectClosedLostReasons(state, salesFunnelId),
  )

  return {
    status,
    reasonDetail,
  }
}
